import * as React from 'react';
import { NotFoundState } from '@app/components/NotFoundState';

/**
 * The router's catch-all, for an address that matches no route at all. The same state a
 * detail page shows for an id that matches no record - see NotFoundState.
 */
const NotFound: React.FunctionComponent = () => <NotFoundState />;

export { NotFound };
